import { get } from 'lodash'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { i18n } from '../../index'
import StationPage from '../station/StationPage'
import IncentiveProductPage from './IncentiveProductPage'
import { fetchStationSalesIncentiveProducts } from './incentiveProductQueries'
import type { ActivityWeight, IncentiveSalesTarget, SalesIncentiveProduct } from './incentiveProductTypes'

type QueryData = {
  stationSalesIncentiveProducts: SalesIncentiveProduct[]
  incentiveSalesTarget: IncentiveSalesTarget
  incentiveSalesTargetNextYear: IncentiveSalesTarget
  activityWeights: Array<ActivityWeight>
}

type QueryVariables = { stationId: string; date: Date; nextYearDate: Date; lastYear: number; currentYear: number }

const StationIncentiveProductPage = () => {
  const currentDate = moment()
  const nextYearDate = currentDate.clone().add(1, 'year')
  const lastYear = currentDate.clone().subtract(1, 'year').year()
  const currentYear = currentDate.year()
  return (
    <StationPage title={i18n.t('admin.stations.title.incentiveSales')}>
      {({ station }) => {
        const variables: QueryVariables = {
          stationId: station.id,
          date: currentDate.toDate(),
          nextYearDate: nextYearDate.toDate(),
          lastYear: lastYear,
          currentYear: currentYear,
        }
        return (
          <Query<QueryData, QueryVariables> query={fetchStationSalesIncentiveProducts} variables={variables}>
            {({ loading, error, data }) => (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <IncentiveProductPage
                  incentiveSalesProducts={get(data, 'stationSalesIncentiveProducts', [])}
                  incentiveSalesTarget={get(data, 'incentiveSalesTarget')}
                  incentiveSalesTargetNextYear={get(data, 'incentiveSalesTargetNextYear')}
                  incentiveSalesWeights={get(data, 'activityWeights')}
                  incentiveSalesLastYear={get(data, 'incentiveSalesLastYear', [])}
                  incentiveSalesCurrentYear={get(data, 'incentiveSalesCurrentYear', [])}
                  variables={variables}
                />
              </Loader>
            )}
          </Query>
        )
      }}
    </StationPage>
  )
}
export default StationIncentiveProductPage
